import { gql, useMutation, useQuery } from '@apollo/client'

import {
  MultiItemSerialDetailFragmentDoc,
  ObtainMultiItemSerialsMutation,
  ObtainMultiItemSerialsMutationVariables,
  QRcodeGetItemMultiQuery,
  QRcodeGetItemMultiQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { router } = useRouter<{ multiItemId: string; status?: 'complete' }>()

  const { data, loading } = useQuery<
    QRcodeGetItemMultiQuery,
    QRcodeGetItemMultiQueryVariables
  >(QUERY, { variables: { id: router.query.multiItemId } })

  const [getItemMulti, { loading: gettingItemMulti }] = useMutation<
    ObtainMultiItemSerialsMutation,
    ObtainMultiItemSerialsMutationVariables
  >(OBTAIN_MULTI_ITEM_SERIALS)

  return {
    state: {
      loading,
      hasNextPage: false,
      isLoggedIn: !!user,
      isAcquired: !!data?.multiItemSerials?.authenticatedAt,
      canBeObtain: !!data?.multiItemSerials?.canBeObtain,
      gettingItemMulti,
      multiItemSerial: data?.multiItemSerials ?? null,
      multiItemId: router.query.multiItemId,
      showCompletedScreen: router.query?.status === 'complete',
    },
    actions: {
      async onFetchMore() {},
      async onGetItemMulti() {
        await getItemMulti({ variables: { id: router.query.multiItemId } })
      },
    },
  }
})

const QUERY = gql`
  query QRcodeGetItemMulti($id: ID!) {
    multiItemSerials(id: $id) {
      ...MultiItemSerialDetail
    }
  }
  ${MultiItemSerialDetailFragmentDoc}
`

const OBTAIN_MULTI_ITEM_SERIALS = gql`
  mutation obtainMultiItemSerials($id: ID!) {
    obtainMultiItemSerials(id: $id) {
      ...MultiItemSerialDetail
    }
  }
  ${MultiItemSerialDetailFragmentDoc}
`
